module.exports = __webpack_public_path__ + "img/IMA_brain_icon@2x.542c3197.png";